type RouteComponentModule = unknown;
type RoutePreloader = () => Promise<RouteComponentModule>;

const ROUTE_COMPONENT_PRELOADERS = {
  '/coach': () => import('@/pages/Coach'),
  '/leaderboard': () => import('@/pages/Leaderboard'),
  '/performance': () => import('@/pages/Performance'),
  '/profile': () => import('@/pages/Profile'),
  '/rewards': () => import('@/pages/Rewards'),
} satisfies Record<string, RoutePreloader>;

type RoutePreloadPath = keyof typeof ROUTE_COMPONENT_PRELOADERS;

export function preloadRouteComponent(path: string): Promise<RouteComponentModule | void> {
  const preloader = ROUTE_COMPONENT_PRELOADERS[path as RoutePreloadPath];
  return preloader ? preloader() : Promise.resolve();
}
